<template>
  
    <v-container>
      <!-- Pending Leads Section -->
      <v-row v-if="pendingLeads.length">
        <v-col cols="12">
          <h2>Pending Leads</h2>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-for="lead in pendingLeads" :key="lead.id">
          <v-card color="yellow">
            <v-card-title>{{ lead.SAL_CONTACT_NAME }}</v-card-title>
            <v-card-subtitle>{{ lead.SAL_CUSTOMER_NAME }}</v-card-subtitle>
            <!-- Add more lead details here -->
            <v-card-actions>
              <!-- <v-btn color="primary" @click="editPendingLead(lead, index)">Edit</v-btn> -->
              <v-btn color="error" @click="deletePendingLead(index)">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Regular Leads Section -->
      <v-row>
        <v-col cols="12">
          <h2>Recent Leads</h2>
        </v-col>
        <!-- Iterate over leads and display them -->
        <v-col cols="12" sm="6" md="4" v-for="lead in leads" :key="lead.id">
          <v-card>
            <v-card-title>{{ lead.customer_name }}</v-card-title>
            <v-card-subtitle>{{ lead.contact_name }}</v-card-subtitle>
            <!-- Add more lead details here -->
            <v-card-text>
              {{ lead }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

</template>

<script>
import secure_axios from "../services/secure_axios";

export default {
  data() {
    return {
      leads: [],
      pendingLeads: [],
      // totalSubmissions: 0,
      // syncedSubmissions: 0,
      // syncingInProgress: false,
    };
  },
  methods: {
    async fetchLeads() {
      const smancode = this.thisUser.USER_DEFAULT_SMAN_DOCNO; 
      const empcode = this.thisUser.USER_EMP_DOCNO; 
      const params = smancode ? { smancode: smancode, empcode :empcode } : {};

      try {
        const response = await secure_axios.get(this.sessionAPI+"leads", { params }); 
        this.leads = response.data;
      } catch (error) {
        console.error('Error fetching leads:', error);
        // Handle error
      }
    },
    fetchPendingLeads() {
      const pendingSubmissions = JSON.parse(localStorage.getItem('pendingSubmissions') || '[]');
      console.log("pendingSubmissions",pendingSubmissions)
      this.pendingLeads = pendingSubmissions;
      console.log("pendingLeads",this.pendingLeads)

    },
    deletePendingLead(index) {
      let pendingSubmissions = JSON.parse(localStorage.getItem('pendingSubmissions') || '[]');
      pendingSubmissions.splice(index, 1);
      localStorage.setItem('pendingSubmissions', JSON.stringify(pendingSubmissions));
      this.fetchPendingLeads();
    },
    postPendingLead(lead, index) {
      this.lead = { ...lead };
      // Optionally, keep track of the index of the lead being edited
      this.editingLeadIndex = index;
      // Navigate to the form view if it's a separate component or show the form in the current component
      // You may need to emit an event or use Vue Router for navigation
    },
    editPendingLead(lead, index) {
      this.lead = { ...lead };
      // Optionally, keep track of the index of the lead being edited
      this.editingLeadIndex = index;
      // Navigate to the form view if it's a separate component or show the form in the current component
      // You may need to emit an event or use Vue Router for navigation
    },
    // handleOnline() {
    //   console.log("Online");
    //   this.syncData();
    // },
    // handleOffline() {
    //   console.log("Offline");
    // },
    // checkNetworkStatus() {
    //   if (navigator.onLine) {
    //     console.log("Online");
    //     this.syncData();
    //   } else {
    //     console.log("Offline");
    //   }
    // },
    // async syncData() {
    //   let pendingSubmissions = JSON.parse(localStorage.getItem('pendingSubmissions') || '[]');
    //   console.log("PENDINGSUBMISSION",pendingSubmissions); 
    //   if (!pendingSubmissions || pendingSubmissions.length === 0) {
    //     // this.$toast.info("No pending submissions to sync.");
    //     return; // Exit the function if there's nothing to sync
    //   }
    //   this.totalSubmissions = pendingSubmissions.length;
    //   this.syncedSubmissions = 0;
    //   this.syncingInProgress = true;

    //   for (let i = 0; i < pendingSubmissions.length; ) {
    //     try {
    //       const data = pendingSubmissions[i];
    //       const response = await secure_axios.post(this.sessionAPI + "newlead", data);
    //       if (response.status === 201) {
    //         console.log("Lead synced successfully", response.data);
    //         this.syncedSubmissions++;
    //         pendingSubmissions.splice(i, 1); // Remove this submission from the array
    //       } else {
    //         i++; // Move to the next submission
    //       }
    //     } catch (error) {
    //       console.error("Error syncing data", error);
    //       i++; // Move to the next submission
    //     }
    //   }

    //   // Notifications
    //   if (this.syncedSubmissions === this.totalSubmissions ) {
    //     this.$toast.success("All leads synced successfully!");
    //   } else {
    //     const failedCount = this.totalSubmissions - this.syncedSubmissions;
    //     this.$toast.error(`${failedCount} lead(s) could not be synced. Please try again.`);
    //   }

    //   // Update pending submissions in localStorage
    //   localStorage.setItem('pendingSubmissions', JSON.stringify(pendingSubmissions));
    //   this.syncingInProgress = false;
    // },
  },
  computed: {       
    sessionAPI() {
      // return this.$store.getters.sessionAPI;
      return "https://tritonfactsapi.ngrok.io/";
    },
    thisUser() {
      return this.$store.getters.factsuser; // Ensure this is the correct Vuex getter
    },
  },
  // mounted() {
  //   const savedLead = localStorage.getItem('leadDraft');
  //   if (savedLead) {
  //     this.lead = JSON.parse(savedLead);
  //   }
  // },
  created() {
    this.fetchLeads();
    this.fetchPendingLeads();
    // window.addEventListener('online', this.handleOnline);
    // window.addEventListener('offline', this.handleOffline);
    // this.checkNetworkStatus();
  }
};
</script>
